import { FilmIcon } from '@heroicons/react/24/outline';
import { Box, Flex, Progress, Space, Text, Title } from '@mantine/core';
import { MIME_TYPES } from '@mantine/dropzone';
import { useDisclosure } from '@mantine/hooks';

import { PageLoading } from '@/pages/PageLoading';
import { useArtistOnBoardVideo } from '@/pages/artist/onboard/components/stages/video/hooks/useArtistOnBoardVideo.ts';
import { translate } from '@/shared/i18n/translate';
import { LBModalLayout } from '@/shared/layouts';
import { LBVideoDropZone } from '@/shared/modules';
import { LBButton } from '@/shared/ui-kit/components';

export const ArtistOnBoardVideo = () => {
  const { state, functions } = useArtistOnBoardVideo();
  const [opened, { open, close }] = useDisclosure();

  const size = import.meta.env.VITE_VIDEO_MAX_SIZE as string;

  if (state.isLoading) return <PageLoading />;

  return (
    <>
      <LBModalLayout opened={opened} onClose={close}>
        <Title order={2}>{translate('popups.videoUploading.title')}</Title>
        <Space h={10} />
        <Text>{translate('popups.videoUploading.description')}</Text>
        <Space h={20} />
        <Box
          style={{
            borderRadius: 8,
            backgroundColor: 'white',
            zIndex: 99
          }}
        >
          <Progress value={state.percentage} w='100%' />
        </Box>
      </LBModalLayout>
      <form onSubmit={functions.onSubmit}>
        <Title order={1}>
          {translate('pages.onboarding.artist.video.title')}
        </Title>
        <Space h={24} />
        <Text fz={14}>
          {translate('pages.onboarding.artist.video.videoForGogoVacancy')}
        </Text>
        <Space h={4} />
        <LBVideoDropZone
          loading={state.form.submitting}
          thumbnailPath={state.form.getValues().dance.thumbanilPath || ''}
          initialValue={
            state.form.getValues().dance.file !== null
              ? [`${state.form.getValues().dance.file}`]
              : []
          }
          onDelete={() =>
            functions.onDeleteVideo(state.form.getValues().dance.id, 'dance')
          }
          onFilesChange={(file) =>
            state.form.setFieldValue('dance.file', file[0])
          }
        >
          <Flex align='center' direction='column' py={70}>
            <FilmIcon color='gray' width={64} />
            <Text c='red' fw={700} fz={16}>
              {translate('commons.uploadFromDevice')}
            </Text>
            <Text fz={12} ta='center'>
              {translate('commons.videoParams', {
                size
              })}
            </Text>
          </Flex>
        </LBVideoDropZone>
        <Space h={16} />

        <Space h={16} />
        <Text fz={14}>
          {translate('pages.onboarding.artist.video.videoForHostesVacancy')}
        </Text>
        <Space h={4} />
        <LBVideoDropZone
          accept={[MIME_TYPES.mp4]}
          loading={state.form.submitting}
          thumbnailPath={state.form.getValues().walk.thumbanilPath || ''}
          initialValue={
            state.form.getValues().walk.file !== null
              ? [`${state.form.getValues().walk.file}`]
              : []
          }
          onDelete={() =>
            functions.onDeleteVideo(state.form.getValues().walk.id, 'walk')
          }
          onFilesChange={(file) =>
            state.form.setFieldValue('walk.file', file[0])
          }
        >
          <Flex align='center' direction='column' py={70}>
            <FilmIcon color='gray' width={64} />
            <Text c='red' fw={700} fz={16}>
              {translate('commons.uploadFromDevice')}
            </Text>{' '}
            <Text fz={12} ta='center'>
              {translate('commons.videoParams', {
                size
              })}
            </Text>
          </Flex>
        </LBVideoDropZone>
        <Space h={16} />

        <Space h={32} />
        <LBButton
          fullWidth
          disabled={!state.isFormValid}
          loading={state.form.submitting}
          type='submit'
          onClick={open}
        >
          {translate('commons.save-and-continue')}
        </LBButton>
      </form>
    </>
  );
};
